<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6">
      <label class="font-lg" :for="id">
        Nº do Cartão SUS
      </label>
      <div class="input-group">
        <the-mask
          type="text"
          placeholder="Digite o nº do cartão SUS..."
          class="form-control"
          maxlength="15"
          v-model="propValue"
          :ref="id"
          :name="id"
          :id="id"
          :mask="'###############'"
          :disabled="carregando"
          @input="$emit('input', propValue)"
        />
        <span class="input-group-btn">
          <button
            class="btn btn-default btn-border"
            @click="$emit('click')"
            :disabled="carregando"
          >
            <span class="sr-only">Botão de pesquisa</span>
            <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'search'" />
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'

export default {
  props: {
    value: {
      type: String
    },
    id: {
      type: String,
      required: true
    },
    carregando: {
      type: Boolean,
      required: true
    }
  },
  components: { TheMask },
  data() {
    return { propValue: this.value }
  },
  watch: {
    value(newValue) {
      this.propValue = newValue
    }
  }
}
</script>

<style scoped>
.btn-border {
  border: 1px solid #468c36;
}
</style>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/InputCartaoSUS.vue